export default {"src":"/_next/static/media/logo-volendam-alt.a69b37b4.svg","height":59,"width":100,"blurWidth":0,"blurHeight":0};